import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-base text-white py-16 px-4 border-t border-white/10 pt-[6px] pb-[6px] space-y-[1px]" data-id="element-139">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-[3px]" data-id="element-140">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-brand-green font-semibold text-sm" data-id="element-141">
          <span data-id="element-142">🌸</span> IMPULSO DIGITAL STORE™
        </div>

        <p className="text-gray-400 leading-relaxed max-w-2xl" data-id="element-143"></p>

        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-sm text-gray-300" data-id="element-144">
          <a href="mailto:soporte@impulsodigitalstore.com" className="flex items-center gap-2 hover:text-brand-green transition-colors" data-id="element-145">
            <Mail size={16} className="text-brand-green" data-id="element-146" />{' '}
            soporte@impulsodigitalstore.com
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-brand-green transition-colors" data-id="element-147">
            <Instagram size={16} className="text-brand-green" data-id="element-148" />{' '}
            @impulsodigital.store
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-brand-green transition-colors" data-id="element-149">
            <Globe size={16} className="text-brand-green" data-id="element-150" />{' '}
            www.impulsodigitalstore.com
          </a>
        </div>

        <div className="w-24 h-px bg-white/10" data-id="element-151"></div>

        <div data-id="element-152">
          <p className="text-2xl font-display italic text-brand-green mb-2" data-id="element-153">
            "El que trabaja con mano diligente gobernará."
            <br data-id="element-154" />
            Prov. 12:24
          </p>
          <p className="text-sm text-gray-500" data-id="element-155">— Impulso Digital Store™ 🌸</p>
        </div>

        <div className="text-xs text-gray-600 space-y-2 pt-8 border-t border-white/10 w-full" data-id="element-156">
          <p data-id="element-157">
            © Impulso Digital Store™ 2026 — Todos los derechos reservados.
          </p>
          <p data-id="element-158">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}